import actions from '../../actionTypes';

export default user => {
  return {
    type: actions.EDITED_SITE_USER,
    user
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/editedSiteUser.js